export default __webpack_public_path__ + "static/media/grayAdd.5631e0c8.svg";